export const REMOTE_DEPOSIT_ADDED_EVENT = 'remote-deposit-added';
